// This file is used to define reducers for the slice, and has no exports

import {
  clearV2DirtyState,
  clearResponseV2Api,
  setBlockCodeFormatting,
  fetchApiPermissionsSuccess,
} from "./actions";
import slice from "./slice";
slice.reducer(clearV2DirtyState, (state, { payload }) => {
  delete state.meta[payload.id].dirty;
});

slice.reducer(clearResponseV2Api, (state, { payload }) => {
  state.meta[payload.id] = {
    ...state.meta[payload.id],
    executionResult: undefined,
    enrichedExecutionResult: undefined,
    editedSinceLastExecution: undefined,
  };
});

slice.reducer(setBlockCodeFormatting, (state, { payload }) => {
  if (
    !state.formatting[payload.apiId] ||
    !state.entities[payload.apiId] ||
    state.meta[payload.apiId]?.isDeleting
  ) {
    return;
  }

  state.formatting[payload.apiId].blocks[payload.blockName] = {
    status: payload.status,
    error: payload.error,
  };
});

slice.reducer(fetchApiPermissionsSuccess.type, (state, { payload }) => {
  state.permissions[payload.apiId] = payload.permissions;
});
